<template>
  <div>
    <div v-if="loadingStatus">
      <v-col cols="12" md="10" sm="10" class="mx-auto">
        <v-skeleton-loader
          :loading="loadingStatus"
          class="ma-2"
          type="card@6"
          elevation="2"
        >
        </v-skeleton-loader>
      </v-col>
    </div>

    <v-sheet v-else elevation="2" class="news-sheet">
      <v-col cols="12" sm="6" md="3" class="mx-auto pb-0">
        <v-text-field
          outlined
          label="Search News"
          prepend-inner-icon="mdi-magnify"
          dense
          class="mb-0"
          v-model="query"
          clearable
          color="teal"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="10"
        sm="10"
        class="mx-auto"
        v-for="news in displayedNews"
        :key="news._id"
      >
        <!-- <base-title-bar
          elevation="2"
          class="text-center"
          color="#17408B"
          :label="`${news.Title}`"
          icon="mdi-baseball-bat"
          height="60"
          textProp="pt-2 pb-1text-subtitle-1 white--text"
        /> -->

        <!--//* goalies cards.. -->
        <v-card class="mx-auto" rounded elevation="2">
          <v-card-text>
            <span class="caption font-weight-black">
              {{ news.Updated | UtcToEst }}
            </span>
            <v-avatar
              color="grey"
              class="float-left mx-2"
              width="50"
              height="50"
            >
              <img :src="news.Teamlogo" alt="" />
            </v-avatar>
            <p class="text-subtitle-1 font-weight-bold">{{ news.Title }}</p>
            <p>{{ news.Content }}</p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        v-if="shouldShowViewMore"
        cols="12"
        md="10"
        sm="10"
        class="mx-auto text-center pb-4"
      >
        <v-btn
          color="green darken-1"
          dark
          @click="showSubscriptionModal = true"
        >
          View More
        </v-btn>
      </v-col>
    </v-sheet>

    <news-subscription-modal
      :showModal="showSubscriptionModal"
      @close="showSubscriptionModal = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import NewsSubscriptionModal from "@/components/Modal/NewsSubscriptionModal.vue";

export default {
  name: "MlbDemoNewsPage",

  components: {
    NewsSubscriptionModal,
  },

  created() {
    this.fetchMlbNews();
  },

  data() {
    return {
      query: "",
      showSubscriptionModal: false,
    };
  },

  computed: {
    ...mapState("MlbModule", ["mlbNews", "loadingStatus"]),
    ...mapState("userModule", ["userState"]),

    planType() {
      return this.userState?.plantype || "";
    },

    isFreeUser() {
      return this.planType === "Free" || this.planType === "";
    },

    searchNews() {
      if (this.mlbNews.data) {
        let news = this.mlbNews.data.map((_news) => {
          _news.hash =
            `${_news.Categories} ${_news.Team} ${_news.Title}`.toLowerCase();
          return _news;
        });

        news = news.filter((n) => n.hash.includes(this.query.toLowerCase()));
        return news;
      }
    },

    displayedNews() {
      if (!this.searchNews) return [];

      if (this.isFreeUser) {
        return this.searchNews.slice(0, 5);
      }
      return this.searchNews;
    },

    shouldShowViewMore() {
      return this.isFreeUser && this.searchNews && this.searchNews.length > 5;
    },
  },

  methods: {
    fetchMlbNews() {
      this.$store.dispatch("MlbModule/getMlbNews");
    },

    estTime(value) {
      const datetime = new Date(value);
      const time = datetime.toLocaleString("en-US", {
        timeZone: "America/New_York",
      });

      console.log(time);
    },
  },
};
</script>
<style scoped>
.news-sheet {
  background: #c2e6cf !important;
}
</style>
